import { ApiWrapper } from '../api';
import { Emergency, OperatorLog } from '../entities';

export class MainPageApi {
    private static _instance: MainPageApi;
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    private constructor() {}
    static getInstance() {
        return this._instance ? this._instance : this._instance = new this();
    }

    fetchEmergencies(): Promise<Emergency[]> {
        return ApiWrapper.performRequest(
            'GET',
            '/v1/emergencies',
            {},
            true
        );
    }

    updateEmergencyStatus(id: string, status: string): Promise<Emergency> {
        return ApiWrapper.performRequest(
            'PATCH',
            `/v1/emergencies/${id}`,
            {
                body: { status: status }
            },
            true
        );
    }

    leftEmergencyFinishedReasonComment(id: string, reasonComment: string): Promise<Emergency> {
        return ApiWrapper.performRequest(
            'PATCH',
            `/v1/emergencies/${id}`,
            {
                body: { finishReason: reasonComment }
            },
            true
        );
    }

    pushEmergencyLog(emergency: Emergency, newStatus: string): Promise<OperatorLog> {
        return ApiWrapper.performRequest(
            'POST',
            '/v1/operator-logs',
            { body: {
                        emergency,
                        workStatus: newStatus
                    }
                },
            true
        )
    }

    addNotesToEmergency(id: string, notes: string): Promise<Emergency> {
        return ApiWrapper.performRequest(
            'PATCH',
            `/v1/emergencies/${id}`,
            {
                body: { notes }
            },
            true
        );
    }
}
